import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";
import { API_SERVER } from "../utils/urlBack_End";

export const loginApi = createApi({
  reducerPath: "loginApi",
  baseQuery: baseQuery(`${API_SERVER}`),
  endpoints: (builder) => ({
    loginCliente: builder.mutation({
      query: (credentials) => ({
        url: "/login",
        method: "POST",
        body: {
          correo: credentials.rutCliente,
          contrasena: credentials.password,
          cliente: true,
        },
      }),
    }),
    loginMain: builder.mutation({
      query: (credentials) => ({
        url: "/login",
        method: "POST",
        body: {
          correo: credentials.correo,
          contrasena: credentials.contrasena,
        },
      }),
    }),
    forgotPassword: builder.mutation({
      query: (usuario) => ({
        url: "/recuperarContrasena",
        method: "POST",
        body: {
          correo: usuario.correo,
          rut: usuario.rut,
        },
      }),
    }),
    solicitarResetPortal: builder.mutation({
      query: (body) => ({
        url: "/portal/solicitarReset",
        method: "POST",
        body,
      }),
    }),
    confirmarResetPortal: builder.mutation({
      query: (body) => ({
        url: "/portal/confirmarReset",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLoginClienteMutation,
  useLoginMainMutation,
  useForgotPasswordMutation,
  useSolicitarResetPortalMutation,
  useConfirmarResetPortalMutation,
} = loginApi;
